import React from 'react'
import './App.css';
import Main from './components/Main'
import Foter from './components/Footer'
import Statewise from './components/Statewise'
function App() {
  return (
    <>
  <Main/>
  <Statewise/>
  <Foter/>

    </>
  );
}

export default App;
